import FormInputTypes from '../../components/atoms/formEnums/formInputTypes';
import viewRelatedLiveSportRoomContents from '../viewRelatedLiveSportRoomContents';

export default {
  title: 'Edit Live App Manager',
  attributeName: 'sportRoomConfigInfoNew',
  fields:[
    {
      attributeName: 'name',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      placeholder: 'Content name',
      label: 'Manager Name',
      required: true,
      helpText: 'Name of the content',
      default:'Master',
      errorText: '',
      disabled:true
    },
    // {
    //   attributeName: 'attachedAPPContent',
    //   label: 'Attach Apps Content',
    //   type: FormInputTypes.RELATIONSHIPFILTER,
    //   helpText: 'Select App contents to be controlled by this manager',
    //   canEdit: true,
    //   canCreate: true,
    //   configFile: viewRelatedLiveAppContents,
    // },
    {
      attributeName: 'attachedSportRoomsContent',
      label: 'Attach Rooms Content',
      type: FormInputTypes.RELATIONSHIPFILTER,
      helpText: 'Select  Room contents to be controlled by this manager',
      canEdit: true,
      canCreate: true,
      configFile: viewRelatedLiveSportRoomContents,
    },
  ],
 
};
